import type { SVGProps } from 'react';

/**
 * The Inbox Clinic mark — the same two-part pulse used by the favicon
 * (apps/clinic-portal/public/icon.svg) and the clinic website.
 *
 * Drawn in `currentColor` rather than the brand purples so it inherits whatever the
 * surface it sits on already sets, the way `SkillViperLogo` does.
 */
export function InboxClinicLogo({
  className = 'h-5 w-5 text-primary',
  ...props
}: SVGProps<SVGSVGElement>) {
  return (
    <svg
      aria-hidden="true"
      viewBox="0 0 48 48"
      fill="currentColor"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M20 28.6l-2.65-5.3q-.2-.4-.575-.6-.375-.2-.775-.2H3.7V11.1q0-1.4 1.025-2.4t2.375-1h33.8q1.4 0 2.4 1t1 2.4v11.4H32.95l-3.6-7.15q-.2-.4-.575-.575Q28.4 14.6 28 14.6t-.775.175q-.375.175-.575.575Z" />
      <path d="M7.1 40.3q-1.35 0-2.375-1.025T3.7 36.9V25.5h11.35l3.6 7.2q.2.4.575.6.375.2.775.2t.775-.2q.375-.2.575-.6L28 19.4l2.65 5.3q.2.4.575.6.375.2.775.2h12.3v11.4q0 1.35-1 2.375T40.9 40.3Z" />
    </svg>
  );
}
